






import { Component, Prop, Vue } from 'vue-property-decorator';
import Scrollable from '@/components/wrappers/Scrollable.vue';

@Component({
  components: { Scrollable },
})
export default class Tab extends Vue {
  @Prop({ required: true }) readonly name!: string;
  private visible = false;

  public setVisible(value: boolean) {
    this.visible = value;
  }
}
